module.exports = __webpack_public_path__ + "img/win_paytable.46f51669.png";